import * as React from 'react';
import { getLocalState, TaUserObject } from '../ta-services/ta-user-service';
import { TaUserData, WIX_ANSWERS_LOGO_WHITE } from '../ta-shared';
import { TaWelcomePageModal } from './ta-welcome-page-modal/comp';
import { TaWelcomePageForm } from './ta-welcome-page-form/comp';
import TaWelcomeText from './ta-welcome-page-text/comp';

export type TaWelcomePageState = {
	isReturningUser: boolean;
	returningUserText: string[];
	isButtonLoading: boolean;
	fullName: string;
	email: string;
	company: string;
};

export type TaWelcomePageProps = {
	onUserSignup: (newUserData: TaUserData) => void;
	onUserReturn: (returnUserData: TaUserObject) => void;
};

export class TaWelcomePage extends React.PureComponent<TaWelcomePageProps, TaWelcomePageState> {
	state: TaWelcomePageState = {
		isReturningUser: false,
		returningUserText: [],
		isButtonLoading: false,
		fullName: '',
		email: '',
		company: '',
	};

	handleInputChange = (key: string, value: string) => {
		this.setState((prevState) => ({
			...prevState,
			[key]: value,
		}));
	}

	handleSignup = async () => {
		const { fullName, email, company } = this.state;
		this.setState({ isButtonLoading: true });
		const returningUser = await getLocalState();
		if (returningUser && returningUser.email === this.state.email) {
			this.setState({ isReturningUser: true });
			if (returningUser.step < 17) {
				const greet = `Welcome back ${this.state.fullName} !`;
				const text = `Would you like to continue where you left off or start over?`;
				this.setState({ returningUserText: [greet, text] });
			} else {
				const greet = `Welcome back ${this.state.fullName} !`;
				const text = `Would you like to continue to your results or start over?`;
				this.setState({ returningUserText: [greet, text] });
			}
		} else {
			this.props.onUserSignup({ fullName, email, company });
		}
	}

	onModalClick = async (val: boolean) => {
		if (val) {
			const user = await getLocalState();
			this.props.onUserReturn(user);
		} else {
			this.handleRestartUser();
		}
	}

	handleRestartUser = async () => {
		this.setState({ isReturningUser: false }, () => {
			const { fullName, email, company } = this.state;
			this.props.onUserSignup({ fullName, email, company });
		});
	}

	renderFormComp = () => {
		const {
			isReturningUser,
			isButtonLoading,
			returningUserText,
			fullName,
			email,
			company,
		} = this.state;

		return isReturningUser ? (
			<TaWelcomePageModal
				returningUserText={returningUserText}
				onModalClick={this.onModalClick}
			/>
		) : (
			<TaWelcomePageForm
				isButtonLoading={isButtonLoading}
				onInputChange={this.handleInputChange}
				onFormSubmit={this.handleSignup}
				formValues={{ fullName, email, company }}
			/>
		);
	}

	render () {
		return (
			<div className='ta-welcome-page-container'>
				<div className='ta-welcome-page-logo'>
					<img src={WIX_ANSWERS_LOGO_WHITE} alt='wix answers logo' />
				</div>
				<section className='ta-welcome-page_left-section'>
					<TaWelcomeText />
				</section>
				<section className='ta-welcome-page_right-section'>
					{this.renderFormComp()}
				</section>
			</div>
		);
	}
}
